import legal1 from "../../assets/legal/pencil.png";

const Termsandconditions = () => {
  return (
    <div className="help_content_page" style={{ height: "max-content" }}>
      <div className="nav_main_header border-b d-md-block d-none">
        <p style={{ fontWeight: 400, fontSize: 30 }}>
          {" "}
          <img src={legal1} alt={"terms and condition"}></img> Terms and
          conditions{" "}
        </p>
      </div>
      <div className="trade_content nav_section border-b">
        {/* <div className="section_header d-flex">
                    <h1><img src={tradeIcon} alt="trade icon" />Trade</h1>
                </div> */}
        <br />
        <br />
        <p style={{ fontSize: 20, lineHeight: 2 }}>
          <strong>
            These Terms and Conditions were last updated on the 2nd of January
            2023.
          </strong>
          <br /> <br /> <br />
          These Terms and Conditions (the “Terms”) define the relation with You
          (“You”) as you interact with our website and/or executing a purchase.
          If You do not agree to be bound by these Terms, do not access or use
          the website. If these Terms are considered an offer, acceptance is
          expressly limited to these Terms.
          <br />
          <br />
          References in this Terms and Conditions (the “Terms”) to “Indexx.ai”,
          “Service”, “Application”, “App” relate to the website, available at
          https://indexx.ai, operated by Indexx.ai Ltd. (The correspondent
          address of the Company shall be at the offices of с/о Hermes Corporate
          Services Ltd., Fifth Floor, Zephyr House, 122 Mary Street, George
          Town, P.O. Box 31493, Grand Cayman KY1 1206, Cayman Islands)
          <br />
          We reserve the right to change these Terms at any time without notice,
          so please check them regularly. Your continued use of or access to the
          website constitutes acceptance of any changes which we might undertake
          to these Terms from time to time subject to no prior notification.
          <br />
          You hereby accept that electronic communication is the only way of
          communication adopted hereby subject to these Terms and your use of
          the website.
          <br />
          <br />
          Please refer to our Privacy Policy regarding submission of the
          personal information through the website.
          <br />
          <br />
          Your Commitments
          <br />
          <br />
          By agreeing to these Terms, You represent and warrant that: (a) your
          age is 18 or older; and (b) the products Your purchase will not be
          used in any illegal or unauthorized way in any jurisdiction of the
          world; and (c) You are able to bear any and all expenses which might
          occur while getting access to and using the website. Providing that
          violation of any of the above statements by You shall entitle us to
          immediately terminate the services and your access to the site.
          <br />
          <br />
          You agree to provide current, complete and accurate purchase and
          account information for all purchases made at our website. You agree
          to promptly update your information, including your email address and
          other necessary details, so that we can complete your transactions and
          contact you as needed.
          <br />
          <br />
          You are prohibited from using the website or its content: (a) for any
          unlawful purpose; (b) to solicit others to perform or participate in
          any unlawful acts; (c) to violate any international, federal,
          provincial or state regulations, rules, laws, or local ordinances; (d)
          to infringe upon or violate our intellectual property rights or the
          intellectual property rights of others; (e) to harass, abuse, insult,
          harm, defame, slander, disparage, intimidate, or discriminate based on
          gender, sexual orientation, religion, ethnicity, race, age, national
          origin, or disability; (f) to submit false or misleading information;
          (g) to upload or transmit viruses or any other type of malicious code
          that will or may be used in any way that will affect the functionality
          or operation of the services or of any related website, other
          websites, or the Internet; (h) to collect or track the personal
          information of others; (i) to spam, phish, pharm, pretext, spider,
          crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to
          interfere with or circumvent the security features of the service or
          any related website, other websites, or the Internet. We reserve the
          right to terminate your access to the website for violating any of the
          prohibited uses.
          <br />
          <br />
          Product Description
          <br />
          <br />
          We attempt to be as accurate as possible, however, we do not warrant
          that product descriptions or other content of the website is accurate,
          complete, reliable, current, or error-free. Any reliance on the
          material on this website is at your own risk. We reserve the right to
          modify the contents of this website at any time, but we have no
          obligation to update any information on our website. We reserve the
          right to limit the quantities of any products or services that we
          offer. We reserve the right to discontinue any product at any time. We
          reserve the right, but are not obligated, to limit the sales of our
          products to any person, geographic region or jurisdiction.
          <br />
          <br />
          We may change the pricing for the products listed on this website at
          any time subject to no notification. We shall not be liable to You or
          to any third-party for any modification, price change, suspension or
          discontinuance of access to the website or services.
          <br />
          <br />
          We reserve the right to refuse service to anyone for any reason at any
          time. We reserve the right to refuse any order you place with us. We
          may, in our sole discretion, limit or cancel quantities purchased per
          person, per household or per order. We reserve the right to limit or
          prohibit orders that, in our sole judgment, appear to be placed by
          dealers, resellers or distributors.
          <br />
          <br />
          While we have made every effort to ensure continuity and security of
          the Services, we are unable to completely foresee and hedge legal,
          technological and other risks including but not limited to force
          majeure, virus, hacker attack, system instability, flaw in third-party
          services, act of government, etc. that may result in service
          interruption, data loss and other losses and risks.
          <br />
          <br />
          Purchase Bonus
          <br />
          <br />
          For the activity on the website and the purchases undertaken via the
          website we retain the right but not an obligation to grant you a
          purchase bonus. We usually grant a purchase bonus in the form of a
          token. Token represents your right to purchase a limited number of
          branded items on our website with the value of the token granted. The
          value of the token depends on your purchase history and will be
          determined at our own discretion. The token is only permitted to be
          used for purchases of a limited number of specifically marked goods on
          our website.
          <br />
          We reserve all rights, title and interest, and all related
          intellectual property rights in and to the tokens produced by us. You
          only are granted a limited, revocable, non-transferable license to use
          the token, and you agree that you do not own them.
          <br />
          <br />
          In no way can the token or its value be exchanged with us or anyone
          else for real money (traditional currency, any other open digital
          currency), goods, other items, or services of monetary value, except
          of stated hereunder. The transfer of token is prohibited except where
          expressly authorized hereunder. Other than expressly authorized
          hereunder you shall not sell, redeem or otherwise transfer token to
          any person or entity, another website user or any third party. Value
          and availability of tokens are subject to change without notice. The
          token is not an instrument of exchange and payment, which please note.
          <br />
          <br />
          We may manage, regulate, control, modify or eliminate available tokens
          as well as goods available to purchase with tokens, at any time with
          our notice. We shall have no liability to you or any third party in
          the event that we exercise any such rights.
          <br />
          <br />
          Risk of Loss
          <br />
          <br />
          All purchases of physical items from the website are made pursuant to
          a shipment contract. This means that the risk of loss and title for
          such items passes to You upon our delivery to the carrier.
          <br />
          <br />
          Return Policy
          <br />
          Please refer to our customer support team for information on the
          return policy.
          <br />
          <br />
          Copyright
          <br />
          All content included in or made available through the website, such as
          text, graphics, logos, button icons, images, audio clips, digital
          downloads, data compilations, and software is our property and
          protected by international copyright laws. The compilation of all
          content included in or made available through the website is our
          exclusive property protected by international copyright laws.
          <br />
          <br />
          Content
          <br />
          <br />
          You may post reviews, comments other content, send communications, so
          long as the content is not illegal, obscene, threatening, defamatory,
          invasive of privacy, infringing of intellectual property rights
          (including publicity rights), or otherwise injurious to third parties
          or objectionable, and does not consist of or contain software viruses,
          political campaigning, commercial solicitation, chain letters, mass
          mailings, or any form of "spam" or unsolicited commercial electronic
          messages. You may not use a false e-mail address, impersonate any
          person or entity, or otherwise mislead. We reserve the right to remove
          or edit such content, but do not regularly review posted content. You
          grant us a nonexclusive, royalty-free, perpetual, irrevocable, and
          fully sublicensable right to use, reproduce, modify, adapt, publish,
          perform, translate, create derivative works from, distribute, and
          display such content throughout the world in any media.
          <br />
          <br />
          Disclaimer And Limitation Of Liability
          <br />
          <br />
          THE SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS
          INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE WEBSITE ARE
          PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. WE DO NOT MAKE ANY
          REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO
          THE OPERATION OF THE SERVICES, THE INFORMATION, CONTENT, MATERIALS,
          PRODUCTS INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
          WEBSITE. YOU EXPRESSLY AGREE THAT YOUR USE OF THE WEBSITE AND SERVICES
          IS AT YOUR SOLE RISK.
          <br />
          WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
          LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
          PARTICULAR PURPOSE. TO THE FULL EXTENT PERMISSIBLE BY LAW, WE WILL NOT
          BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF
          SERVICES, OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS MADE
          AVAILABLE TO YOU THROUGH THE WEBSITE, INCLUDING, BUT NOT LIMITED TO
          DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES.
          <br />
          <br />
          Miscellaneous
          <br />
          <br />
          SEVERABILITY. In the event that any provision of these Terms is
          determined to be unlawful, void or unenforceable, such provision shall
          nonetheless be enforceable to the fullest extent permitted by
          applicable law, and the unenforceable portion shall be deemed to be
          severed from these Terms, such determination shall not affect the
          validity and enforceability of any other remaining provisions.
          <br />
          ENTIRE AGREEMENT. The failure to exercise or enforce any right or
          provision of these Terms shall not constitute a waiver of such right
          or provision. These Terms and any policies or operating rules posted
          by us on this website constitute the entire agreement and
          understanding between you and us, superseding any prior or
          contemporaneous agreements, communications and proposals, whether oral
          or written, between you and us.
          <br />
          <br />
          GOVERNING LAW. These Terms and your use of the website will be
          governed by and construed in accordance with the laws of England and
          Wales. By agreeing to the Terms, You acknowledge that You are required
          to resolve any claim that You may have against us on an individual
          basis in arbitration. You agree to notify us of any dispute within 30
          days of when it arises, that you will attempt informal resolution
          prior to any demand for arbitration and that arbitration will be
          conducted confidentially by a single arbitrator.
          <br />
          CONTACT INFORMATION. You may submit any questions, suggestions,
          issues, complaints to us to the following address: support@indexx.ai.
        </p>
      </div>
    </div>
  );
};

export default Termsandconditions;
